/**
 * Util class that allows to bind events to document and automatically unbind them
 * when their nodes are removed from DOM.
 */
export class DocumentBind {
    private static INSTANCE: DocumentBind = new DocumentBind();
    private bindedEvents: {
        [key: string]: RegisteredListener[];
    } = {};

    private constructor() {
        let observer = new MutationObserver(this.mutationCallback);
        let config = {
            childList: true,
            characterData: false,
            attributes: false,
            subtree: true,
        };
        observer.observe(document.body, config);
    }

    private findMatched(element: Element) {
        const m = [];
        for (const key of Object.keys(this.bindedEvents)) {
            let matched;
            if (element.getAttribute("id") === key) {
                matched = element;
            } else {
                matched = element.querySelector("#" + key);
            }
            if (matched != null) {
                m.push(matched);
            }
        }
        return m;
    }

    private mutationCallback: MutationCallback = (mutations: MutationRecord[]) => {
        for (const mutation of mutations) {
            for (const node of Array.from(mutation.removedNodes)) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                    if ((node as Element).classList[0] === "js-stack-holder__inner") {
                        return;
                    }
                    const found = this.findMatched(node as Element);
                    for (const item of found) {
                        for (const e of this.bindedEvents[item.id]) {
                            document.removeEventListener(e.eventName, e.listener);
                        }
                        delete this.bindedEvents[item.id];
                    }
                }
            }
        }
    }


    public static bindEvent(id: string, eventName: string, listener: EventListener) {
        DocumentBind.INSTANCE.bindInstance(id, eventName, listener);
    }

    private bindInstance(id: string, eventName: string, listener: EventListener) {
        if (this.bindedEvents[id] == null) {
            this.bindedEvents[id] = [];
        }
        this.bindedEvents[id].push({
            eventName,
            listener,
        });
        document.addEventListener(eventName, listener);
    }
}

interface RegisteredListener {
    eventName: string;
    listener: EventListener;
}
